<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan Premis Perkhidmatan Diberi Konsultasi">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">

            <w-flex class="mt3 filter-row">
               <div class="filter-col">
                  <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id"  @input="getBandar()" />
               </div>
               <div class="filter-col">
                  <z-select style="margin:5px;" :items="bandar" class="mt4" label="Daerah"  v-model="pencarian.lkp_bandar_id" />
               </div>
               <div class="filter-col">
                  <z-select style="margin:5px; " v-model="pencarian.lkp_art_id" :items="lkp_art" label="Jenis Perkhidmatan" />
               </div>
            </w-flex>

            <w-flex class="mt3 filter-row">
               <div class="filter-col">
                  <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis_id" label="ID Premis" />
              <!-- <w-input class="mt4" label="Tarikh Lahir" type="date" v-model="pencarian.tarikh_lahir"/>   -->
               </div>
               <div class="filter-col">
                  <w-input 
                    label="Tarikh Perkhidmatan Dari" 
                    type="date" 
                    v-model="pencarian.tarikh_perkhidmatan_dari"
                  />
               </div>
               <div class="filter-col">
                  <w-input 
                    label="Tarikh Perkhidmatan Hingga" 
                    type="date" 
                    v-model="pencarian.tarikh_perkhidmatan_hingga"
                  />
               </div>
            </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PREMIS PERKHIDMATAN DIBERI KONSULTASI'">
          <template #title>
            SENARAI LAPORAN PREMIS PERKHIDMATAN DIBERI KONSULTASI
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="1%" rowspan="2">BIL</th> 
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" rowspan="2">Bulan</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="5%" rowspan="2">Tahun</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="9%" rowspan="2">Tarikh Lawatan Pertama</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="40%" colspan="3">Maklumat Penternak</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="20%" rowspan="2">PERKHIDMATAN</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;" width="10%" rowspan="2">BILANGAN SESI KONSULTASI</th>
                  </tr>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                  <!-- Penternak -->
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Nama Penternak</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">ID Premis</th>
                    <th class="w-table__header text-center" style="border: 1px solid #000; background:#d6e4f5;">Daerah</th>
                  
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-center" colspan="7"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">

                    <tr class="w-table__row">
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ (items.current_page - 1) * items.per_page + ind + 1 }}
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.bulan_nama ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tahun ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                          {{$zutil.dateformat(dt.tarikh_perkhidmatan) ?? '-'}}
                        </td>
                  <!-- Penternak -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_penternak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_premis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.daerah ?? '-'}}</td>
                  <!-- Induk -->
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.lkp_art_nama ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">{{dt.jumlah_art ?? '-'}}</td>
                        
                    </tr>
                  </template>

                     <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="9">
                           &nbsp;
                        </td>
                     </tr>
                     <tr class="w-table__row">
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="8">
                           JUMLAH
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                           {{jumlah_per_page}}
                        </td>
                     </tr>
                     <tr class="w-table__row">
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="8">
                           JUMLAH KESELURUHAN KONSULTASI (BILANGAN)
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" >
                           {{jumlah_keseluruhan}}
                        </td>
                     </tr>
                </tbody>
              </table>
              <br><br>
            </div>
          </div>
           <w-flex justify-end class="mt3">
                <nav class="pagination">
                  <button
                  class="pagination-btn"
                  :disabled="!items.prev_page_url"
                  @click="paginate(items.prev_page_url)"
                  >
                    Sebelumnya 
                  </button>

                  <span class="pagination-info">
                    {{ items.current_page }} dari {{ items.last_page }}
                  </span>
                 

                  <button
                  class="pagination-btn"
                  :disabled="!items.next_page_url"
                  @click="paginate(items.next_page_url)"
                  >
                    Seterusnya
                  </button>
                </nav>
              </w-flex>
        </w-card>
        <br>
        <br>
        <br>
        <br>
        <br>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    jumlah_per_page: Number,
    jumlah_keseluruhan: Number,
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'laporan.anak.ai'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan KPI', route: '/laporan' },
        { label: 'Premis Perkhidmatan Diberi Konsultasi', route: 'laporan/premis_perkhidmatan' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
      

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_jenis_baka_id: '',
         lkp_art_id: '',
         premis_id: '',
         tarikh_lahir_dari: '',
         tarikh_lahir_hingga: '',
      },
      negeri:[],
      bandar:[],
      premis_id: [],
      lkp_art: [],
      
      
    }
  },
  methods: {
    paginate(url) {
    this.$inertia.get(url, {}, {
      preserveState: true,
      preserveScroll: true,
    });
    },
   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

   getNegeri(){
        this.$zcomm.get(this.api_service + 'lookup/negeri/'+1, {}).then(res => {
          this.negeri = res

        })
      },
   getBandar(){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.pencarian.lkp_negeri_id, {}).then(res => {
          this.bandar = res
        })
      },

   getPremisCarian(){
         this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
           this.premis_id = res
         })
       },

    getArt(){
      this.$zcomm.get(this.api_service + 'lookup/art', {}).then(res => {
        this.lkp_art = res
      })
    },

   createExcel() {
    const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_jenis_baka_id: this.pencarian.lkp_jenis_baka_id || '',
         lkp_art_id: this.pencarian.lkp_art_id || '',
         premis_id: this.pencarian.premis_id || '',
         tarikh_perkhidmatan_dari: this.pencarian.tarikh_perkhidmatan_dari || '',
         tarikh_perkhidmatan_hingga: this.pencarian.tarikh_perkhidmatan_hingga || '',
         excel: 1 // penanda untuk generate Excel
      };

      const queryString = new URLSearchParams(params).toString();
      const url = route('kpi.premis_perkhidmatan') + '?' + queryString;

    // const url = route('laporan.anak.ai') + '?' + new URLSearchParams(params).toString();

    window.open(url, '_blank');
  }

  


  },

  watch: {

  },

  mounted() {
   this.getJenisBaka();
   this.getNegeri(); 
   this.getPremisCarian();
   this.getArt();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 32px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
